<template>
    <UTooltip :text="showError? `Ugyldig antall (må være større enn ${QUANTITY_MIN})` : ''">
        <UInput
            v-model="quantity"
            type="number"
            size="sm"
            placeholder="Antall"
            min="0.01"
            :disabled="disabled"
            :color="showError ? 'error': 'neutral'"
            :highlight="showError"
            :ui="{ base: 'spinnerless text-right'}"
            data-cy="invoice-creator-quantity"
            @blur="touched = true"
        />
    </UTooltip>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
const QUANTITY_MIN=0.01


const quantity = defineModel<number>('modelValue', {required: true})
defineProps({
    disabled: {type: Boolean, default: false}
})
const touched = ref(false)

const quantityValid = computed(() => {
    return quantity.value >= QUANTITY_MIN
})

const showError = computed(() => {
    return touched.value && !quantityValid.value
})
</script>

<style scoped>

</style>